import _ from 'lodash';
import React, {
  useCallback,
  useState
} from 'react';

import { MoreVert } from '@mui/icons-material';
import {
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { UserMenu } from 'modules/components/layer17';
import * as ds from './dataService';



export type UserTableProps = {
  organizationId?: string;
};

export const FC = (props: UserTableProps) => {
  const { data } = ds.useQuery(props.organizationId);
  const __headers = _.compact([
    'Name',
    'Preferred Email',
    'Phone Number',
    'Active',
    props.organizationId ? '' : 'User Type',
    'Created On'
  ]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {__headers.map((header) => (
              <TableCell
                key={header}
                variant='head'
              >
                {header}
              </TableCell>
            ))}

            <TableCell variant='head' />
          </TableRow>
        </TableHead>

        <TableBody>
          {data.rows.map((person) => (
            <UserTableRow
              key={person.id}
              {...person}
              hideUserTypeRow={!_.isNil(props.organizationId)}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};



type IUserTableRowProps = {
  hideUserTypeRow?: boolean;
  id: string;
  fullName: string;
  preferredEmail: string;
  phone: string;
  active: boolean;
  superAdmin: boolean;
  createdOn: string;
};



const UserTableRow = (props: IUserTableRowProps) => {
  const [
    anchorEl,
    setAnchorEl
  ] = useState<null | HTMLElement>(null);



  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget),
    []
  );

  const handleClose = useCallback(() => setAnchorEl(null), []);



  return (
    <>
      <TableRow>
        <TableCell variant='body'>
          {props.fullName.toString()}
        </TableCell>

        <TableCell variant='body'>
          {props.preferredEmail}
        </TableCell>

        <TableCell variant='body'>
          {props.phone}
        </TableCell>

        <TableCell variant='body'>
          {props.active
            ? <Chip variant='active' label='Active' />
            : <Chip variant='disabled' label='Disabled' />}
        </TableCell>

        {!props.hideUserTypeRow && (
          <TableCell variant='body'>
            {props.superAdmin
              ? <Chip variant='warn' label='Super Admin' />
              : <Chip variant='active' label='User' />}
          </TableCell>
        )}

        <TableCell variant='body'>
          {props.createdOn}
        </TableCell>

        <TableCell align='right'>
          <IconButton onClick={(e) => handleClick(e)}>
            <MoreVert />
          </IconButton>
        </TableCell>
      </TableRow>

      <UserMenu.FC
        anchorEl={anchorEl}
        open={!_.isNil(anchorEl)}
        handleClick={handleClick}
        handleClose={handleClose}
        isActive={props.active}
        personId={props.id}
      />
    </>
  );
};
